import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ServicioComun from "../../../servicios/Comun";
import servicioUsuario from "../../../servicios/servicioUsuario";
import servicioCambiosCic from "../../../servicios/servicioCambiosCic";
import ListadoSolicitudesCambio from "../../../componentes/CambiosCic/ListadoSolicitudesCambioCic/ListadoSolicitudesCambioCic";
import ParametroConsultaDetalle from "../../../Contenedores/CambiosCic/ParametroConsultaDetalle";
import DetalleSolicitudCambioCicConAcciones from "../../../componentes/CambiosCic/DetalleSolicitudCambioCic/DetalleSolicitudCambioCicConAcciones";
import TipoPersonaDropdown from "../../../componentes/Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import { nombreDeRol } from "../../../constantes/nombreDeRol";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Notificar } from "../../../componentes/Comunes/Notificador";

function SolicitudesDeCambio() {
  const [entidades, setEntidades] = useState([]);
  const [entidad, setEntidad] = useState("");
  const [tipoPersona, setTipoPersona] = useState("0");
  const [identificacion, setIdentificacion] = useState("");
  const [nombre, setNombre] = useState("");
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [estados, setEstados] = useState([]);
  const [estadosSeleccionados, setEstadosSeleccionados] = useState([]);
  const [consecutivo, setConsecutivo] = useState("");
  const [solicitudesCambioCic, setSolicitudesCambioCic] = useState([]);
  const [DetalleSolicitud, setDetalleSolicitud] = useState([]);
  const [VerDetalle, setVerDetalle] = useState(false);
  const [
    excluirSolicitudDeLaListaAlFinalizar,
    setExcluirSolicitudDeLaListaAlFinalizar,
  ] = useState(false);

  useEffect(() => {
    async function CargarEntidades() {
      const entidades =
        await ServicioComun.ObtengaEntidadesPrincipalYRelacionadas();
      setEntidades(entidades);
      setEntidad(entidades[0].id);
    }

    CargarEntidades();
  }, []);

  useEffect(() => {
    async function cargarEstados() {
      const estados = await servicioCambiosCic.obtenerEstadosSolicitudCambio();
      setEstados(estados);
    }

    cargarEstados();
  }, []);

  const handleConsecutivoChange = (event) => {
    const valorIntroducido = event.target.value;
    const valorPermitido = valorIntroducido.replace(/[^0-9-]/g, "");
    const secciones = valorPermitido.split("-");
    const seccionNumero = secciones[0];
    const maximoDigitosNumero = 11;
    const seccionYear = secciones[1];
    const maximoDigitosYear = 4;

    //sección del número consecutivo
    if (secciones.length === 1) {
      if (
        seccionNumero.length >= maximoDigitosNumero &&
        consecutivo.length === seccionNumero.length - 1
      ) {
        setConsecutivo(
          seccionNumero.substring(0, maximoDigitosNumero) +
            " - " +
            seccionNumero.substring(maximoDigitosNumero)
        );
      } else {
        setConsecutivo(seccionNumero.substring(0, maximoDigitosNumero));
      }
    }

    //sección del año
    if (secciones.length === 2) {
      if (seccionYear.length > 0 || consecutivo.split("-").length === 1) {
        setConsecutivo(
          seccionNumero.substring(0, maximoDigitosNumero) +
            " - " +
            seccionYear.substring(0, maximoDigitosYear)
        );
      } else {
        setConsecutivo(seccionNumero.substring(0, maximoDigitosNumero));
      }
    }
  };

  async function obtenerSolicitudesDeCambio() {
    setExcluirSolicitudDeLaListaAlFinalizar(false);

    let entidadSeleccionada = [
      {
        id: !entidad ? null : entidad,
      },
    ];
    const parametro = {
      EntidadesConsulta: entidadSeleccionada,
      identificacion: !identificacion ? null : identificacion,
      tipoPersona: tipoPersona === "0" ? null : tipoPersona,
      nombreDeudor: !nombre ? null : nombre,
      fechaDesde: !fechaDesde ? null : moment(fechaDesde).format("YYYY-MM-DD"),
      fechaHasta: !fechaHasta ? null : moment(fechaHasta).format("YYYY-MM-DD"),
      consecutivoSolicitud: !consecutivo ? null : consecutivo,
      tipoEstadoSolicitudActualLista: !estadosSeleccionados.length
        ? null
        : estadosSeleccionados.map((estado) => estado.value),
    };

    await ConsultarListaSolicitudesCambioCic(parametro);
  }

  async function obtenerSolicitudesPorAprobar() {
    setExcluirSolicitudDeLaListaAlFinalizar(true);

    const parametro = {
      EntidadesConsulta: null,
      tipoEstadoSolicitudActualLista: [2, 4],
    };

    await ConsultarListaSolicitudesCambioCic(parametro);
    BorrarParametros();
  }

  async function obtenerSolicitudesEnProceso() {
    setExcluirSolicitudDeLaListaAlFinalizar(true);

    const parametro = {
      EntidadesConsulta: null,
      tipoEstadoSolicitudActualLista: [2, 4, 8],
    };

    await ConsultarListaSolicitudesCambioCic(parametro);
    BorrarParametros();
  }

  function BorrarParametros() {
    setEntidad(entidades[0].id);
    setEstadosSeleccionados([]);
    setConsecutivo("");
    setIdentificacion("");
    setFechaDesde("");
    setFechaHasta("");
    setTipoPersona("0");
    setNombre("");
  }

  async function ConsultarListaSolicitudesCambioCic(parametro) {
    const resultado =
      await servicioCambiosCic.ObtengaListadoSolicitudesCambioCic(parametro);

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    setSolicitudesCambioCic(resultado.solicitudesCambioCic);
  }

  const ObtengaDatosSolicitud = useCallback(async (datos) => {
    let parametro = new ParametroConsultaDetalle();
    parametro.Solicitud = datos.solicitud;
    parametro.EntidadSolicitud = datos.entidad?.id;
    var detalle = await servicioCambiosCic.ObtengaDetalleSolicitudCambioCic(
      parametro
    );

    setDetalleSolicitud(detalle);
    setVerDetalle(true);
  }, []);

  const eliminarSolicitudDeLaLista = useCallback(
    (solicitud) => {
      const nuevaLista = solicitudesCambioCic.filter(
        (x) => x.solicitud !== solicitud.solicitud
      );
      setSolicitudesCambioCic(nuevaLista);
    },
    [solicitudesCambioCic]
  );

  const actualizarSolicitudEnLaLista = useCallback(
    (solicitud) => {
      const listaActualizada = solicitudesCambioCic.map((x) =>
        x.solicitud === solicitud.solicitud ? solicitud : x
      );
      setSolicitudesCambioCic(listaActualizada);
    },
    [solicitudesCambioCic]
  );

  const VolverAVerResultados = useCallback(
    async (datos) => {
      setVerDetalle(false);

      if (datos.vuelvePorBotonRegresar) {
        return;
      }

      if (
        excluirSolicitudDeLaListaAlFinalizar ||
        datos.excluirSolicitudDeLaLista
      ) {
        eliminarSolicitudDeLaLista(datos.solicitud);
        Notificar("success", datos.mensaje);
        return;
      }

      actualizarSolicitudEnLaLista(datos.solicitud);
    },
    [
      excluirSolicitudDeLaListaAlFinalizar,
      eliminarSolicitudDeLaLista,
      actualizarSolicitudEnLaLista,
    ]
  );

  return (
    <Layout>
      {!VerDetalle ? (
        <>
          <div className="row">
            <div className="col">
              <PageHeading title="Solicitudes de Cambio CIC" />
            </div>
            <div className="col">
              <div className="text-right">
                {servicioUsuario.tieneRol(nombreDeRol.CambiosCicAprobar) ? (
                  <button
                    className="btn btn-primary btn-icon-split mr-3"
                    onClick={obtenerSolicitudesPorAprobar}
                  >
                    <span className="icon text-white-50">
                      <i className="far fa-check-circle"></i>
                    </span>
                    <span className="text">Ver Solicitudes por Aprobar</span>
                  </button>
                ) : null}
                {servicioUsuario.tieneRol(nombreDeRol.CambiosCicSolicitar) ? (
                  <button
                    onClick={obtenerSolicitudesEnProceso}
                    type="button"
                    className="btn btn-primary btn-icon-split"
                  >
                    <span className="icon text-white-50">
                      <i className="fas fa-hourglass-half"></i>
                    </span>
                    <span className="text">Ver Solicitudes en Proceso</span>
                  </button>
                ) : null}
              </div>
            </div>
          </div>

          <div className="card shadow mb-4">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Filtros de Búsqueda
              </h6>
            </div>
            <div className="card-body">
              <div className="form-row">
                {entidades.length > 1 && (
                  <div className="form-group col">
                    <label htmlFor="entidad">Entidad</label>
                    <select
                      className="form-control"
                      id="entidad"
                      name="entidad"
                      value={entidad}
                      onChange={(e) => setEntidad(e.target.value)}
                    >
                      {entidades.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.alias}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="form-group col">
                  <label htmlFor="tipoPersona">Tipo Persona</label>
                  <TipoPersonaDropdown
                    id="tipoPersona"
                    name="tipoPersona"
                    value={tipoPersona}
                    permiteSeleccionarValorDefault="true"
                    onChange={(e) => setTipoPersona(e.target.value)}
                  ></TipoPersonaDropdown>
                </div>

                <div className="form-group col">
                  <label htmlFor="identificacion">Identificación</label>
                  <input
                    className="form-control"
                    id="identificacion"
                    name="identificacion"
                    type="text"
                    maxLength="30"
                    value={identificacion}
                    onChange={(e) =>
                      setIdentificacion(e.target.value.toUpperCase())
                    }
                  />
                </div>

                <div className="form-group col">
                  <label htmlFor="nombre">Nombre o Razón Social</label>
                  <input
                    className="form-control"
                    id="nombre"
                    name="nombre"
                    type="text"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value.toUpperCase())}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col">
                  <label htmlFor="fechaDesde">Fecha Desde</label>
                  <DatePicker
                    placeholderText="Fecha Desde"
                    locale="es"
                    selected={fechaDesde}
                    onChange={(fecha) => setFechaDesde(fecha)}
                    id="fechaDesde"
                    name="fechaDesde"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    wrapperClassName="w-100"
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    maxDate={moment(new Date()).toDate()}
                  />
                </div>

                <div className="form-group col">
                  <label htmlFor="fechaHasta">Fecha Hasta</label>
                  <DatePicker
                    placeholderText="Fecha Hasta"
                    locale="es"
                    selected={fechaHasta}
                    onChange={(fecha) => setFechaHasta(fecha)}
                    id="fechaHasta"
                    name="fechaHasta"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    wrapperClassName="w-100"
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    maxDate={moment(new Date()).toDate()}
                  />
                </div>

                <div className="form-group col">
                  <label htmlFor="consecutivo">Consecutivo</label>
                  <input
                    className="form-control"
                    id="consecutivo"
                    name="consecutivo"
                    type="text"
                    value={consecutivo}
                    onChange={handleConsecutivoChange}
                  />
                </div>

                <div className="form-group col">
                  <label htmlFor="estado">Estado</label>
                  <Select
                    placeholder="Seleccione..."
                    isMulti
                    id="estado"
                    name="estado"
                    value={estadosSeleccionados}
                    onChange={(estadoSeleccionado) =>
                      setEstadosSeleccionados(estadoSeleccionado)
                    }
                    options={estados.map((item) => ({
                      value: item.codigo,
                      label: item.descripcion,
                    }))}
                    noOptionsMessage={() => "No hay más opciones"}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? "#3bb1ff" : "#d1d3e2",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(0, 112, 186, 0.25)"
                          : "none",
                        "&:hover": {
                          borderColor: state.isFocused ? "#3bb1ff" : "#d1d3e2",
                        },
                      }),
                    }}
                  />
                </div>
              </div>

              <button
                type="button"
                id="buscar"
                className="btn btn-primary btn-icon-split"
                onClick={obtenerSolicitudesDeCambio}
              >
                <span className="icon text-white-50">
                  <i className="fas fa-search"></i>
                </span>
                <span className="text">Buscar</span>
              </button>

              <button
                id="btnLimpiarFiltros"
                onClick={BorrarParametros}
                type="button"
                className="btn btn-sm btn-light ml-3"
              >
                <i className="fas fa-redo fa-sm mr-1"></i>
                Limpiar filtros
              </button>
            </div>
          </div>
        </>
      ) : null}

      {!VerDetalle ? (
        <ListadoSolicitudesCambio
          solicitudesDeCambioCic={solicitudesCambioCic}
          ObtengaDatosSolicitud={ObtengaDatosSolicitud}
        />
      ) : null}

      {VerDetalle ? (
        <DetalleSolicitudCambioCicConAcciones
          DetalleModificarSolicitud={DetalleSolicitud}
          VolverAVerResultados={VolverAVerResultados}
          ListaSolicitudes={solicitudesCambioCic}
        />
      ) : null}
    </Layout>
  );
}
export default SolicitudesDeCambio;
